function isMatchingCriteria(feedback, criteria) {
  return feedback.criteria_node_id === criteria.id && feedback.data.criteria_node.grading_value_type === criteria.grading_value_type;
}
function findMostRecentlyCreatedMatchingFeedback(feedback, isMatching) {
  let mostRecent;
  for (const candidate of feedback ?? []) {
    if (!isMatching(candidate)) {
      continue;
    }
    if (!mostRecent || candidate.created_at > mostRecent.created_at) {
      mostRecent = candidate;
    }
  }
  return mostRecent;
}
function findMatchingCriteriaFeedback(feedback, criteria) {
  return findMostRecentlyCreatedMatchingFeedback(
    feedback,
    (candidate) => isMatchingCriteria(candidate, criteria)
  );
}
function filterMatchingCriteriaFeedback(feedback, criteria) {
  if (!feedback) return [];
  return feedback.filter((f) => isMatchingCriteria(f, criteria));
}
function isMatchingSection(feedback, sectionId) {
  return feedback.criteria_node_id === sectionId && feedback.data.criteria_node.grading_value_type === "section";
}
function findMatchingSectionFeedback(feedback, sectionId) {
  return findMostRecentlyCreatedMatchingFeedback(
    feedback,
    (candidate) => isMatchingSection(candidate, sectionId)
  );
}
function filterMatchingSectionFeedback(feedback, sectionId) {
  if (!feedback) return [];
  return feedback.filter((f) => isMatchingSection(f, sectionId));
}
const sectionIsNotApplicableValueToDisplayValue = (isNotApplicable) => isNotApplicable ? "N/A" : "Applicable";
export {
  filterMatchingCriteriaFeedback,
  filterMatchingSectionFeedback,
  findMatchingCriteriaFeedback,
  findMatchingSectionFeedback,
  sectionIsNotApplicableValueToDisplayValue
};
//# sourceMappingURL=recordingAssessmentFeedbackHelpers.js.map
